export default __webpack_public_path__ + "static/media/gallery-wip-grenade v2_07.d3adcbf2.jpg";